import { SET_FEEDBACK_REFRESH } from './actionTypes';

const initialState = {
	lastRefreshTime: null,
};

export default (state = initialState, { type, payload }) => {
	switch (type) {
		case SET_FEEDBACK_REFRESH:
			return {
				...state,
				lastRefreshTime: payload,
			};
		default:
			return state;
	}
};
